import { useRef, useState } from "react"

import { useMutation } from "@apollo/client"
import { Box, Button, CircularProgress, ClickAwayListener, Popper, Typography } from "@mui/material"

import { INSERT_BAT_SIGNAL_EVENT_DATA } from "../../app/graphql/mutations"
import { useAppSelector } from "../../app/store/hooks"
import { GreyCallPhoneBatsignal, GreyCancelPhoneBatSignal } from "../../utils/iconRefs/authIcons"
import styles from './NeedHelpButton.module.css'
import { useLocation } from "react-router-dom"
import { logEvents } from "../../utils/logging"

const NeedHelpButton = () => {

  const location = useLocation()

  const phone = useAppSelector(state => state.auth.otpLogin.phone)

  const [isCalling, setIsCalling] = useState<boolean>(false)
  const [popperState, setPopperState] = useState<boolean>(false)

  const popperTarget = useRef(null)

  const [insertBatsignalNeedHelp, { loading: insertingBatSignal }] = useMutation(INSERT_BAT_SIGNAL_EVENT_DATA)

  const callSubmit = async () => {

    logEvents('null', isCalling ? 'APP_BATSIGNAL_CANCEL' : 'APP_BATSIGNAL_CALL', {
      userId: null,
    })

    await insertBatsignalNeedHelp({
      variables: {
        eventData: {
          currentPage: location.pathname,
          phone,
          modeOfCommunication: isCalling ? 'cancel' : 'call',
        }
      },
      onCompleted: () => {
        if (!isCalling) setPopperState(!popperState)
        setIsCalling(!isCalling)
      },
      onError: (error) => {
        console.log(error)
        // TODO: need a way to handle error
      }
    })
  }

  return (
    <>
      <Button className={styles.needHelpButton} onClick={callSubmit} ref={popperTarget}>
        {!isCalling ? <>
          <GreyCallPhoneBatsignal />
          <Typography className={styles.needHelpText}>Need Help?</Typography>
          {insertingBatSignal && <CircularProgress size={17} />}
        </> :
          <>
            <GreyCancelPhoneBatSignal />
            <Typography className={styles.needHelpText}>Cancel Call?</Typography>
            {insertingBatSignal && <CircularProgress size={17} />}
          </>}
      </Button>
      <ClickAwayListener onClickAway={() => setPopperState(false)}>
        <Popper anchorEl={popperTarget.current} open={popperState} >
          <Box className={styles.popperBox} onClick={() => setPopperState(false)}>
            Our team will call you shortly
          </Box>
        </Popper>
      </ClickAwayListener>
    </>
  )
}

export default NeedHelpButton